"use client";

import { OrdersBack } from "@/components/orders-back";
import { Button } from "@/components/ui/button";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";

export function OrdersBackToggle() {
    const trigger = (
        <Button variant="ghost" size="icon" className="z-50" title="Go back">
            <ChevronLeftIcon className="h-5 w-5" />
            <span className="sr-only">Go back</span>
        </Button>
    );

    return <OrdersBack trigger={trigger} />;
}
